// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const DECLINE_INVITATION = "Zru\u0161 pozv\u00e1nku";
export const INVITATION_SENT_ON_when = "pozvan\u00e1 %(when)s";
export const OPEN_INVITATION = "Zobraz pozv\u00e1nku";
